import {API_ADMIN_URL, API_BASE_URL} from '../../../config/constants'
import { postRequest, getRequest } from '../../API'

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const list = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : changeStatus
* Description   : change status
* By            : Md Rashd Ali
* Date          : 18-12-2024 
*********************************************************/
export const changeStatus = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/change-status`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function



/*********************************************************
* Function Name : addeditdata
* Description   : change service status
* By            : Md Rashid Ali
* Date          : 19-12-2024 
*********************************************************/
export const addeditdata = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/addeditdata`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : deleteInvoice
* Description   : Delete invoice
* By            : Afsar Ali
* Date          : 20-11-2024 
*********************************************************/
export const deletePromocode = async (option) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/delete`,
            postData : option
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 11-12-2024 
*********************************************************/
export const orderHistory = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/order-history`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : List
* Description   : Get list of all service category
* By            : Md Rashid Ali
* Date          : 20-12-2024 
*********************************************************/
export const cancelOrderPromocode = async (option) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/order-cancel`,
            postData : option
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function
/*********************************************************
* Function Name : voucherList
* Description   : Get list of all voucher
* By            : Afsar Ali
* Date          : 29-01-2025 
*********************************************************/
export const voucherList = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}promocode/voucher-list`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count : res?.data?.response?.count};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : orderDetails
* Description   : Get promo code order details
* By            : Afsar Ali
* Date          : 26-08-2025
*********************************************************/
export const orderDetails = async (order_id="") =>{
    try {
        const params = {
            url : `${API_BASE_URL}v1/promocode/order-details/${order_id}`,
        }
        const res = await getRequest(params);
        return {status : true, result : res};
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : raffleCouponDetails
* Description   : Get raffle coupon details by coupon code
* Date          : 24-06-2026
*********************************************************/
export const raffleCouponDetails = async (couponCode = "") => {
    try {
        const params = {
            url: `${API_BASE_URL}v1/promocode/raffle-coupon/${couponCode}`,
        };
        const res = await getRequest(params);
        if (!res) {
            return { status: false, message: "Coupon not found." };
        }
        return { status: true, result: res };
    } catch (error) {
        console.log(error);
        return { status: false, message: "Under Maintenance, Please try after some time." };
    }
};//End of Function